import { h } from 'vue';
import { openPanel } from '@/layouts/layouts';
import ReportViewer from "@/components/ReportViewer";
import { reportData } from '@/api/reports';

export async function report(caption: string, reportName: string, params: any) {
	try {
		const raw: any = await reportData(reportName, params);
		// часть API отдаёт { complete, data }, отчёты — сам dataset
		const dataset =
			raw &&
			typeof raw === 'object' &&
			raw.complete != null &&
			raw.data != null &&
			raw.organization == null &&
			raw.items == null
				? raw.data
				: raw;

		openPanel({
			caption,
			onCreate: (panel: any) => ({ component: h(ReportViewer, { panel, dataset, reportName }) })
		})
	} catch (error: any) {
		console.error(error.message);
	}
}
	